import { actionTypes as at, actionCreators } from '../actions';
import { ActionType } from 'typesafe-actions';
import Types from 'Types';


export type Action = ActionType<typeof actionCreators>;

export const initialState = {
  data: null,
  loading: false,  
};

export const reducer = (state = initialState, { type, payload }: Action & Types.StoreAction) => {
  switch (type) {
      case at.CHECK_RESET_PASSWORD_CODE:
        return {
          data: null,
          loading: true,
        }
      case at.CHECK_RESET_PASSWORD_CODE_ERROR:
        return {
          ...state,
          loading: false,
          error: payload,
        }
      case at.CHECK_RESET_PASSWORD_CODE_SUCCESS:
        return {
          ...state,
          loading: false,
          data: payload,
        }
      default:
        return state;
  }
};

export const isLoading = ({ submitForm: { checkResetPasswordCode } }: Types.StoreState) => checkResetPasswordCode.loading;

export const getData = ({ submitForm: { checkResetPasswordCode } }: Types.StoreState) => checkResetPasswordCode.data;

